<template>
  <v-card id="results">
    <v-card-title>
      Voting results
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="resultsHeaders"
        :items="results"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'VotingResults',
  props: {
    results: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    resultsHeaders() {
      return [
        { text: 'Standing', value: 'standing' },
        { text: 'Team', value: 'name' },
        { text: 'Final Score', value: 'finalScore.total' },
        { text: 'Awesomeness', value: 'finalScore.awesomeness' },
        { text: 'Innovation', value: 'finalScore.innovation' },
        { text: 'Completeness', value: 'finalScore.completeness' },
        { text: 'Utility', value: 'finalScore.utility' },
        { text: 'Difficulty', value: 'finalScore.difficulty' },
        { text: 'Prizes', value: 'prizes' },
      ];
    },
  },
};
</script>
